"use client";

import { useTemplateContext } from "context/template/TemplateContext";
import { useIsScreenMd } from "hooks/useIsScreenMd";
import dynamic from "next/dynamic";
import { FC, ReactNode } from "react";
import { SidebarMobileDrawer } from "components/ui/v2/sidebar/sidebar-mobile-drawer";
import { TemplateType } from "stores/template/useTemplateStore";
import SidebarV2 from "../Sidebar/SidebarV2";

const NavBar = dynamic(() => import("components/NavBar/NavBar"), {
  ssr: false
});

interface ManagerProLayoutProps {
  children?: ReactNode;
}

const ManagerProLayout: FC<ManagerProLayoutProps> = ({ children }) => {
  const { template } = useTemplateContext();
  const isScreenMd = useIsScreenMd();

  return (
    <div
      className="flex h-dvh w-full max-w-full overflow-x-visible bg-slate-50/60 dark:bg-zinc-950"
      id="site-container"
    >
      {(template === TemplateType.Classic ||
        template === TemplateType.Aurora) &&
        !isScreenMd && <SidebarMobileDrawer />}

      <div
        className="app-layout-shell relative flex h-full min-h-0 w-full flex-1 flex-col justify-start transition-[padding-top] duration-300 ease-out"
        style={{
          paddingTop: "var(--app-navbar-offset, var(--app-navbar-height, 56px))",
          transitionTimingFunction: "cubic-bezier(0.32,0.72,0,1)",
        }}
      >
        <NavBar />
        <div
          id="app-main-scroll"
          className="relative flex min-h-0 w-full flex-1 flex-col overflow-y-auto [overflow-x:clip]"
        >
          <div
            className="dashboard-container relative mx-auto flex w-full max-w-max-size-grid flex-1 flex-col gap-1 overflow-visible"
            id="manager-container"
          >
            <div className="flex min-h-0 flex-1 flex-row gap-1">
              {template === TemplateType.Aurora && isScreenMd ? (
                <div
                  className="sidebar-v2-slot z-[6000] w-[var(--sidebar-width-collapsed)] min-w-[var(--sidebar-width-collapsed)] shrink-0"
                  id="sidebar-v2"
                >
                  <SidebarV2 render />
                </div>
              ) : null}
              <div className="relative z-0 min-h-0 min-w-0 flex-1">
                {children}
              </div>
            </div>
          </div>
        </div>
      </div>
      <style jsx global>{`
        #app-main-scroll {
          height: calc(
            100dvh - var(--app-navbar-offset, var(--app-navbar-height, 56px))
          );
        }

        .dashboard-container {
          width: 100%;
        }

        #sidebar-v2 {
          position: sticky !important;
          top: 0;
          align-self: flex-start;
          z-index: 10050;
          overflow: visible;
          width: var(--sidebar-width-collapsed);
          min-width: var(--sidebar-width-collapsed);
          height: calc(100dvh - var(--app-navbar-offset, var(--app-navbar-height, 56px)));
        }
      `}</style>
    </div>
  );
};

export default ManagerProLayout;
